// 37-question animation project brief — grouped into 7 sections.
// Each question id (q1..q37+) maps across all languages.

export const QUESTIONNAIRE = {
  sections: [
    { id: "basics", ids: ["q1", "q2", "q3", "q4"] },
    { id: "message", ids: ["q5", "q6", "q7", "q8", "q9", "q10"] },
    { id: "concept", ids: ["q11", "q12"] },
    { id: "visual", ids: ["q13", "q14", "q15", "q16", "q17", "q18", "q19", "q20", "q21"] },
    { id: "animation_audio", ids: ["q22", "q23", "q24", "q25", "q26"] },
    { id: "communication", ids: ["q27", "q28", "q29", "q30", "q31", "q32"] },
    { id: "legal", ids: ["q33", "q34", "q35", "q36", "q37", "q_extra"] },
  ],
};

export const QUESTIONNAIRE_I18N = {
  en: {
    intro: {
      title: "New Project",
      lead: "If you don't know the answer yet or are unsure, just put a dash ( – ). Once you complete the brief, Ksenia will reply within 48h with feedback and help you figure out the remaining points.",
      escrow: "Deals can also be processed through Dribbble, which serves as a secure escrow platform for both parties.",
      workflow_title: "Workflow & Approvals",
      workflow: [
        "Concept / Script — goals, format, style, deadlines.",
        "Storyboard / Visual Direction — sketches, composition, style.",
        "Animation — frame-by-frame work and motion graphics.",
        "Final Compositing / Export — edit, sound, color, VFX, delivery.",
      ],
      approvals: "Each stage must be approved before moving to the next. Feedback window: 3 working days per stage; otherwise auto-approved.",
      payment_title: "Payment Terms",
      payment: "Work begins after a 50% or 100% upfront payment. If 50% deposit, the balance is due on final approval before delivery.",
      submit: "Submit project request",
      cta: "Start a new project",
      success_title: "Brief received",
      success_text: "Ksenia will review it and reply within 48h. You can track status and chat in your dashboard.",
      goto_dashboard: "Go to dashboard",
    },
    sections: {
      basics: "Project Basics",
      message: "Message & Distribution",
      concept: "Concept & Story",
      visual: "Visual & Branding",
      animation_audio: "Animation & Audio",
      communication: "Communication & Timeline",
      legal: "Legal, Budget & Other",
    },
    q: {
      q1: { label: "Company / Brand / Project name", hint: "" },
      q2: { label: "What is the goal of this animated video?", hint: "Drive sales, brand awareness, product explainer, presentation, social media, ads, a gift, storytelling, etc." },
      q3: { label: "What core problem or task should it address?", hint: "" },
      q4: { label: "Who is the target audience for this video?", hint: "Age, interests, profession, location." },
      q5: { label: "What is the key takeaway and emotional response? What is the overall mood?", hint: "Inspiring, whimsical, serious, dynamic, etc." },
      q6: { label: "Where will the video be distributed?", hint: "Social media, ads, website, etc." },
      q7: { label: "Video specifications", hint: "Aspect ratio (vertical/square/horizontal). Resolution (Full HD 1920×1080, 4K, etc). Final file format (MP4, MOV, etc)." },
      q8: { label: "Will you need versioning or optimization for multiple platforms?", hint: "" },
      q9: { label: "Do you require captions or subtitles?", hint: "" },
      q10: { label: "What is the target duration / runtime?", hint: "" },
      q11: { label: "Do you have an existing concept or script?", hint: "If so, please describe it briefly." },
      q12: { label: "Scene-by-scene breakdown", hint: "Example: 5–6 locations. Scene 1 intro; Scenes 2–4 plot development; Finale resolution." },
      q13: { label: "Visual style", hint: "Color palette (pastel, vibrant, neon, etc). Art / drawing style. Overall vibe (romantic, humorous, cinematic, etc). Backgrounds (minimalist / medium detail)." },
      q14: { label: "Visual references you LIKE (links + why)", hint: "" },
      q15: { label: "Anti-references — examples you DISLIKE (links + why)", hint: "" },
      q16: { label: "Do you have a brand book or brand identity guidelines?", hint: "Or should this animation be independent of them?" },
      q17: { label: "Do you have a logo? Should it be featured or integrated?", hint: "" },
      q18: { label: "Transition preferences between scenes", hint: "Simple cuts / seamless / creative effects." },
      q19: { label: "Preferred frame rate (FPS) and smoothness?", hint: "Recommended: 12–15 fps — the indie hand-drawn standard. Lively and artistic without inflating budget." },
      q20: { label: "Characters", hint: "If you have existing designs, share images / links. How many characters? If we design from scratch, attach reference styles. Should any character be based on a real person? Attach photos if yes." },
      q21: { label: "Anything to AVOID? Specific visuals, themes, or elements?", hint: "" },
      q22: { label: "Animation pacing and complexity", hint: "Low (static, lipsync) / Medium (walking, simple actions) / High (running, fights, complex physics). Give a ratio, e.g. '80% calm dialogue, 20% epic jump'." },
      q23: { label: "Videos with a similar vibe / style (links)", hint: "" },
      q24: { label: "Do you require voiceover or audio production?", hint: "" },
      q25: { label: "Video language?", hint: "" },
      q26: { label: "Audio / sound design preferences", hint: "" },
      q27: { label: "Target deadline & critical milestone dates?", hint: "" },
      q28: { label: "Preferred days and hours for communication?", hint: "" },
      q29: { label: "Preferred communication format", hint: "Text / calls / voice messages." },
      q30: { label: "Preferred communication style", hint: "Formal or casual." },
      q31: { label: "Typical turnaround for feedback? Your time zone?", hint: "" },
      q32: { label: "Who has final approval authority?", hint: "" },
      q33: { label: "AI guidelines — restrictions on AI tools?", hint: "Prohibited / allowed for prototyping / allowed for final assets." },
      q34: { label: "Estimated budget — is there a pre-approved budget?", hint: "" },
      q35: { label: "Can this project be used in Kuryarti's portfolio?", hint: "" },
      q36: { label: "Formal contract or verbal agreement? Billing details, closing documents required?", hint: "" },
      q37: { label: "Intellectual property — full copyright buyout?", hint: "Note: transferring full exclusive rights adds 70% to the project cost." },
      q_extra: { label: "Anything else important we haven't discussed?", hint: "" },
    },
  },

  ru: {
    intro: {
      title: "Новый проект",
      lead: "Если ответа пока нет — поставьте прочерк ( – ). После заполнения брифа Ксения ответит в течение 48ч и поможет уточнить остальные пункты.",
      escrow: "Сделку можно провести через Dribbble — безопасный эскроу для обеих сторон.",
      workflow_title: "Процесс и согласования",
      workflow: [
        "Концепт / Сценарий — цели, формат, стиль, сроки.",
        "Раскадровка / Визуальный курс — скетчи, композиция, стиль.",
        "Анимация — покадровая работа и motion-графика.",
        "Финальный композ / Экспорт — монтаж, звук, цвет, VFX, сдача.",
      ],
      approvals: "Каждый этап утверждается до перехода к следующему. Окно фидбэка: 3 рабочих дня, иначе авто-утверждение.",
      payment_title: "Оплата",
      payment: "Работа начинается после 50% или 100% предоплаты. При 50% — остаток до сдачи финала.",
      submit: "Отправить заявку",
      cta: "Начать новый проект",
      success_title: "Бриф получен",
      success_text: "Ксения рассмотрит и ответит в течение 48ч. Статус и чат — в вашем кабинете.",
      goto_dashboard: "В кабинет",
    },
    sections: {
      basics: "О проекте",
      message: "Сообщение и площадки",
      concept: "Концепт и история",
      visual: "Визуал и бренд",
      animation_audio: "Анимация и аудио",
      communication: "Связь и сроки",
      legal: "Право, бюджет и прочее",
    },
    q: {
      q1: { label: "Компания / Бренд / Название проекта", hint: "" },
      q2: { label: "Цель анимационного видео?", hint: "Продажи, узнаваемость, объяснение продукта, презентация, соцсети, реклама, подарок, история и т.д." },
      q3: { label: "Какую задачу или проблему оно решает?", hint: "" },
      q4: { label: "Целевая аудитория?", hint: "Возраст, интересы, профессия, локация." },
      q5: { label: "Ключевая мысль, эмоция, общее настроение?", hint: "Вдохновляющее, ироничное, серьёзное, динамичное и т.д." },
      q6: { label: "Где будет показано видео?", hint: "Соцсети, реклама, сайт и т.п." },
      q7: { label: "Спецификации", hint: "Соотношение сторон (вертикаль/квадрат/горизонталь), разрешение (Full HD, 4K), формат файла (MP4, MOV…)." },
      q8: { label: "Нужны версии под разные платформы?", hint: "" },
      q9: { label: "Нужны субтитры / титры?", hint: "" },
      q10: { label: "Желаемая длительность?", hint: "" },
      q11: { label: "Уже есть концепт или сценарий?", hint: "Опишите кратко, если да." },
      q12: { label: "Разбивка по сценам", hint: "Пример: 5–6 локаций. Сцена 1 — вступление; 2–4 — развитие сюжета; финал — развязка." },
      q13: { label: "Визуальный стиль", hint: "Палитра (пастель, яркая, неон), стиль рисования, общий вайб, фоны (минимализм / средняя детализация)." },
      q14: { label: "Референсы, которые НРАВЯТСЯ (ссылки и почему)", hint: "" },
      q15: { label: "Анти-референсы — что НЕ нравится (ссылки и почему)", hint: "" },
      q16: { label: "Есть ли brand book / гайдлайны?", hint: "Или анимация может быть независимой от них?" },
      q17: { label: "Есть ли логотип? Нужно ли интегрировать?", hint: "" },
      q18: { label: "Переходы между сценами", hint: "Простые срезы / плавные / креативные эффекты." },
      q19: { label: "Желаемый FPS и плавность?", hint: "Рекомендую 12–15 fps — стандарт инди и hand-drawn. Живо и художественно без раздувания бюджета." },
      q20: { label: "Персонажи", hint: "Если есть готовые — поделитесь. Сколько персонажей? Если рисуем с нуля — приложите референсы стилей. Есть ли реальные прототипы? Приложите фото." },
      q21: { label: "Чего ИЗБЕГАТЬ? Темы, элементы, образы?", hint: "" },
      q22: { label: "Темп и сложность анимации", hint: "Низкая (статика, lipsync) / Средняя (ходьба, простые жесты) / Высокая (бой, бег, сложная физика). Приведите соотношение." },
      q23: { label: "Видео-референсы со схожим вайбом (ссылки)", hint: "" },
      q24: { label: "Нужны озвучка / звук?", hint: "" },
      q25: { label: "Язык видео?", hint: "" },
      q26: { label: "Предпочтения по аудио / саунд-дизайну?", hint: "" },
      q27: { label: "Дедлайн и ключевые контрольные точки?", hint: "" },
      q28: { label: "Удобные дни и часы для связи?", hint: "" },
      q29: { label: "Формат связи", hint: "Текст / звонки / голосовые." },
      q30: { label: "Стиль общения", hint: "Формальный или дружеский." },
      q31: { label: "Срок реакции на фидбэк? Часовой пояс?", hint: "" },
      q32: { label: "Кто принимает финальные решения?", hint: "" },
      q33: { label: "Правила по ИИ — есть ли ограничения?", hint: "Полный запрет / только для прототипов / разрешено для финала." },
      q34: { label: "Оценочный бюджет — есть согласованный?", hint: "" },
      q35: { label: "Можно ли использовать проект в портфолио Kuryarti?", hint: "" },
      q36: { label: "Договор или устная договорённость? Какие закрывающие документы нужны?", hint: "" },
      q37: { label: "Права — нужен полный выкуп?", hint: "Передача исключительных прав добавляет 70% к стоимости." },
      q_extra: { label: "Что ещё важно обсудить?", hint: "" },
    },
  },

  es: {
    intro: {
      title: "Nuevo Proyecto",
      lead: "Si aún no sabes la respuesta o no estás seguro/a, pon un guión ( – ). Una vez completes el brief, Ksenia responderá en 48h con feedback y te ayudará a definir los puntos restantes.",
      escrow: "El acuerdo también puede gestionarse vía Dribbble, que funciona como escrow seguro para ambas partes.",
      workflow_title: "Flujo y Aprobaciones",
      workflow: [
        "Concepto / Guión — objetivos, formato, estilo, plazos.",
        "Storyboard / Dirección Visual — sketches, composición, estilo.",
        "Animación — cuadro a cuadro y motion graphics.",
        "Composición Final / Export — edición, sonido, color, VFX, entrega.",
      ],
      approvals: "Cada etapa debe ser aprobada antes de pasar a la siguiente. Ventana de feedback: 3 días hábiles por etapa; si no hay respuesta, se aprueba automáticamente.",
      payment_title: "Términos de Pago",
      payment: "El trabajo inicia tras un pago del 50% o 100% por adelantado. Con 50% de depósito, el saldo se cobra al aprobar el final, antes de la entrega.",
      submit: "Enviar solicitud",
      cta: "Iniciar nuevo proyecto",
      success_title: "Brief recibido",
      success_text: "Ksenia lo revisará y responderá en 48h. Puedes seguir el estado y chatear en tu panel.",
      goto_dashboard: "Ir al panel",
    },
    sections: {
      basics: "Bases del Proyecto",
      message: "Mensaje y Distribución",
      concept: "Concepto e Historia",
      visual: "Visual y Marca",
      animation_audio: "Animación y Audio",
      communication: "Comunicación y Plazos",
      legal: "Legal, Presupuesto y Otros",
    },
    q: {
      q1: { label: "Empresa / Marca / Nombre del proyecto", hint: "" },
      q2: { label: "¿Cuál es el objetivo de este video animado?", hint: "Ventas, awareness, explicación de producto, presentación, redes, ads, regalo, storytelling, etc." },
      q3: { label: "¿Qué problema o tarea central debe resolver?", hint: "" },
      q4: { label: "¿Audiencia objetivo?", hint: "Edad, intereses, profesión, ubicación." },
      q5: { label: "¿Mensaje clave, emoción y mood general?", hint: "Inspirador, irónico, serio, dinámico, etc." },
      q6: { label: "¿Dónde se distribuirá el video?", hint: "Redes, ads, web, etc." },
      q7: { label: "Especificaciones del video", hint: "Relación de aspecto (vertical/cuadrado/horizontal). Resolución (Full HD 1920×1080, 4K). Formato final (MP4, MOV…)." },
      q8: { label: "¿Necesitas versiones para múltiples plataformas?", hint: "" },
      q9: { label: "¿Requieres subtítulos o captions?", hint: "" },
      q10: { label: "¿Duración objetivo?", hint: "" },
      q11: { label: "¿Tienes concepto o guión existente?", hint: "Si sí, descríbelo brevemente." },
      q12: { label: "Desglose escena por escena", hint: "Ejemplo: 5–6 locaciones. Escena 1 intro; 2–4 desarrollo; final resolución." },
      q13: { label: "Estilo visual", hint: "Paleta (pastel, vibrante, neón), estilo de dibujo, vibe general, fondos (minimalistas / detalle medio)." },
      q14: { label: "Referencias que TE GUSTAN (links + por qué)", hint: "" },
      q15: { label: "Anti-referencias — ejemplos que NO te gustan (links + por qué)", hint: "" },
      q16: { label: "¿Tienes brand book o guías de marca?", hint: "¿O la animación debe ser independiente?" },
      q17: { label: "¿Tienes logo? ¿Debe aparecer o integrarse?", hint: "" },
      q18: { label: "Preferencias de transiciones entre escenas", hint: "Cortes simples / fluidas / efectos creativos." },
      q19: { label: "¿FPS preferido y fluidez?", hint: "Recomiendo 12–15 fps — estándar indie hand-drawn. Vivaz y artístico sin inflar presupuesto." },
      q20: { label: "Personajes", hint: "Si ya existen, comparte imágenes/links. ¿Cuántos? Si se diseñan desde cero, adjunta referencias. ¿Alguno basado en personas reales? Adjunta fotos." },
      q21: { label: "¿Algo que EVITAR? Visuales, temas o elementos.", hint: "" },
      q22: { label: "Ritmo y complejidad de animación", hint: "Baja (estático, lipsync) / Media (caminar, gestos) / Alta (pelea, correr, física compleja). Da una proporción." },
      q23: { label: "Videos con vibe / estilo similar (links)", hint: "" },
      q24: { label: "¿Necesitas voz en off o producción de audio?", hint: "" },
      q25: { label: "¿Idioma del video?", hint: "" },
      q26: { label: "Preferencias de audio / sound design", hint: "" },
      q27: { label: "¿Deadline objetivo y fechas críticas?", hint: "" },
      q28: { label: "¿Días y horarios preferidos para comunicación?", hint: "" },
      q29: { label: "Formato de comunicación", hint: "Texto / llamadas / mensajes de voz." },
      q30: { label: "Estilo de comunicación", hint: "Formal o casual." },
      q31: { label: "Tiempo típico de feedback / zona horaria", hint: "" },
      q32: { label: "¿Quién tiene la autoridad de aprobación final?", hint: "" },
      q33: { label: "Lineamientos sobre IA — ¿restricciones?", hint: "Prohibida / solo para prototipado / permitida en assets finales." },
      q34: { label: "¿Presupuesto estimado / pre-aprobado?", hint: "" },
      q35: { label: "¿Se puede usar este proyecto en el portafolio de Kuryarti?", hint: "" },
      q36: { label: "¿Contrato formal o acuerdo verbal? Detalles de facturación y documentos de cierre.", hint: "" },
      q37: { label: "Derechos — ¿buyout total de copyright?", hint: "Nota: la cesión exclusiva total agrega 70% al costo del proyecto." },
      q_extra: { label: "¿Algo más importante que no hemos discutido?", hint: "" },
    },
  },
};
